import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'scCentsToEuro',
  standalone: true,
})
export class CentsToEuroPipe implements PipeTransform {
  transform(value: number): string {
    return (value / 100).toFixed(2);
  }
}
